import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Box,
    Dialog,
    IconButton,
    Button,
    Slide,
    Theme,
    Toolbar,
    Paper,
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardActions
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import {selectTabs, selectApplication,
        selectIsFetching as selectIsFetchingApplication} from "./appSlice";
import {getAppName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { useUser } from "../../hooks/useUser";

export const AppHomeScreen = () => {

  let {appName, objectName} = useParams();

  const theme = useTheme();
  const styles = ContainerClasses();
  const {accessToken, onInvalidToken} = useAuth();

  const application = useSelector(selectApplication);
  const isFetchingApplication = useSelector(selectIsFetchingApplication);

  const {userProfile} = useUser();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if(hour >= 5 && hour < 12) return `Good Morning ${userProfile?.First_Name_c}`;
    if(hour >= 12 && hour < 14) return `Good Day ${userProfile?.First_Name_c}`;
    if(hour >= 14 && hour < 18) return `Good Afternoon ${userProfile?.First_Name_c}`;
    if(hour >= 18 && hour < 22) return `Good Evening ${userProfile?.First_Name_c}`;
    return `Good Night ${userProfile?.First_Name_c}`;
  }


  return (
     <Box>
      <Card sx={styles.containerCard}>
         <CardContent>
           {getGreeting()}, welcome to the {application?.Label_sys} application.
         </CardContent>
      </Card>

     </Box>

);
};
